import { useTranslation } from 'react-i18next'

import { Text } from './UI'

export const IsAgentComponent = ({
    children,
    isAgent
}: {
    children: React.ReactNode
    isAgent: boolean
}) => {
    const { t } = useTranslation()

    return (
        <section
            className={`${
                isAgent
                    ? 'bg-gradient-to-b from-blue-50 to-green-50 p-4 rounded-xl shadow-md border border-green-100'
                    : ''
            }`}
        >
            {isAgent && (
                <div className="px-8 py-3 rounded-full bg-gradient-to-r from-[#005BB5] to-[#00BF68] shadow-md">
                    <Text
                        text={t('collaborator.title')}
                        className="text-white text-center"
                    />
                </div>
            )}
            {children}
        </section>
    )
}
